const conditionForSavingTheWBView = ({ username, roles, wbCreatedBy }) => {
  if (username === wbCreatedBy || roles.includes("Admin")) {
    return true;
  } else {
    return false;
  }
};
export { conditionForSavingTheWBView };
